<script setup lang="ts">
// ===== 1. IMPORTS =====
import { type ToastOptions } from 'vue3-toastify'

// ===== 2. TYPE DEFINITIONS =====
interface Props {
  closeToast?: (e?: MouseEvent) => void
  toastProps?: ToastOptions
  text?: string
  icon?: string
  iconClass?: string
  showCloseButton?: boolean
}

// ===== 3. PROPS =====
const {
  closeToast = () => {},
  toastProps = null,
  text = 'Toast',
  icon = null,
  iconClass = null,
  showCloseButton = true
} = defineProps<Props>()

// ===== 4. EMITS =====

// ===== 5. COMPOSABLES & EXTERNAL DEPENDENCIES =====

// ===== 6. REACTIVE DATA =====

// ===== 7. COMPUTED PROPERTIES =====

// ===== 8. WATCHERS =====

// ===== 9. LIFECYCLE HOOKS =====

// ===== 10. METHODS =====
</script>

<template>
  <div class="empty-toast-root">
    <FontAwesomeIcon
      v-if="icon?.length"
      :icon="icon"
      class="icon-size-1"
      :class="iconClass"
    />

    <span class="text">{{ text }}</span>

    <button v-if="showCloseButton" class="btn circle" @click="closeToast">
      <FontAwesomeIcon icon="fa-light fa-xmark" class="icon-size-1" />

      <!-- TODO localize -->
      <span class="sr-only">Close toast</span>
    </button>
  </div>
</template>

<style scoped>
.empty-toast-root {
  display: flex;
  gap: var(--size-1);
  align-items: center;

  color: var(--gray-12);
}

.text {
  flex: 1;
  font-variation-settings: 'wght' 500;
}
</style>
